import { MetricCard } from "./shared/MetricCard";
import { useDatadogQuery } from "../DatadogAnalytics/useDatadogQuery";

type MetricData = {
  value: number;
  diff_percentage: number;
};

type AnalyticsMetricCardProps = {
  chartType: Parameters<typeof useDatadogQuery>[0]["chartType"];
  title: string;
  description?: string;
  format?: "currency" | "percentage" | "number";
  className?: string;
};

/**
 * A `MetricCard` backed by the analytics endpoint. Fetches a single
 * `{ value, diff_percentage }` metric for the given `chartType`.
 */
export function AnalyticsMetricCard({
  chartType,
  title,
  description,
  format = "number",
  className,
}: AnalyticsMetricCardProps) {
  const { ref, queryStatus, data, error, refetch } =
    useDatadogQuery<MetricData>({ chartType });

  return (
    <MetricCard
      ref={ref}
      title={title}
      description={description}
      format={format}
      value={data?.value ?? 0}
      diffPercentage={data?.diff_percentage}
      className={className}
      queryStatus={queryStatus}
      error={error}
      retry={refetch}
    />
  );
}
